<div class="container-fluid">
  <div class="row vh-100">
    <div class="mx-auto card-parent px-0 px-sm-4 align-self-center">
      <div class="card min-vh-100 custom-background shadow border-0">
        <div class="card-header px-4 bg-transparent border-bottom-0 mt-3 bg-white">
          <div class="d-flex justify-content-between">
            <div class="min-w-40px">
              <a class="btn py-0" *ngIf="showPreviousButton" (click)="onClickPrevious()">
                <i class="fa fa-arrow-left align-self-center"></i>
              </a>
            </div>
            <p class="mb-0 text-givt-purple text-center text-heavy-font p-0 m-0"
              *ngIf="titleTranslationKey && titleTranslationKey?.length > 0" [translate]="titleTranslationKey"></p>
            <div class="min-w-40px">
              <app-questionmark [title]="questionMarkTitle" *ngIf="questionMarkTitle" [text]="questionMarkText"
                class="card-titlebar-button">
              </app-questionmark>
              <app-questionmark-picture [title]="questionMarkPictureTitle" *ngIf="questionMarkPictureTitle"
                [text]="questionMarkPictureText" [picturePath]="questionMarkPicturePath"
                [pictureAlt]="questionMarkPictureAlt" class="card-titlebar-button">
              </app-questionmark-picture>
              <a class="btn py-0" (click)="onClickClose()" *ngIf="showCloseButton">
                <i class="fa fa-times align-self-center"></i>
              </a>
            </div>
          </div>
        </div>
        <div class="card-body px-4 container">
          <div class="row d-flex">
            <div class="col-12 col-md-6 mb-3 mb-md-0 d-flex"
              [ngClass]="{'col-md-12': !showSideInfo, 'custom-border-right': showSideInfo}">
              <div class="container d-flex justify-content-center align-content-center">
                <div class="row align-content-center">
                  <div class="col-12 p-0 mb-3 mb-md-5 d-flex justify-content-center">
                    <div class="circle-blue h-100px w-100px shadow d-flex justify-content-center align-items-center">
                      <i class="fas fa-newspaper fa-3x text-white"></i>
                    </div>
                  </div>
                  <div class="col-12 p-0">
                    <p class="text-givt-purple text-light-font text-center" [translate]="description"></p>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-6 align-self-center" [ngClass]="{'col-md-12': !showSideInfo}">
              <ng-content select="[body]">
              </ng-content>
            </div>
          </div>
        </div>
        <div class="card-footer border-0 bg-transparent pb-4 px-4 d-flex justify-content-end">
          <button bottom type="submit" [translate]
            class="px-4 btn btn-lg bg-givt-purple text-white text-heavy-font bottom-button px-5" [disabled]="loading">
            <span class="text-white text-heavy-font" translate>
              <i *ngIf="loading" class="fas fa-spinner fa-spin mr-2"></i>
              onboardingOrganisationDetailsVerifyOrganisationNameComponent.next
            </span>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>